/**
 * variant-picker-fix.js — Fixes for forced-dropdown variant options
 *
 * ROOT CAUSE: theme.js syncCurrentOptions uses querySelectorAll('select, fieldset')
 * which returns BOTH a fieldset AND its nested <select> for forced-dropdown options.
 * This produces a broken currentOptions array (wrong length, undefined entries),
 * causing findVariantByOptions to fail, setInputStates to remove all [selected]
 * attributes, and selectedOptionValues to send incomplete IDs in the section
 * rendering URL → Shopify renders with default values → bonnet/confort reset.
 *
 * Fix 1: syncCurrentOptions — iterate fieldsets only (one per product option).
 *         For fieldsets containing a <select>, read select.value.
 *         For fieldsets with radios, read the checked radio value.
 *
 * Fix 2: updateAvailableOptions — use closest('fieldset') instead of parentElement
 *         for the skip-self check, so selects inside wrapper divs are correctly
 *         identified as belonging to their parent fieldset group.
 */
(function () {
  'use strict';

  var PickerClass = customElements.get('variant-picker');
  if (!PickerClass) return;

  var proto = PickerClass.prototype;

  /* ── Fix 1: syncCurrentOptions ── */
  proto.syncCurrentOptions = function (target) {
    this.currentOptions = Array.from(
      this.querySelectorAll('fieldset')
    )
      .filter(function (fs) { return !fs.closest('bed-size-helper'); })
      .map(function (fs) {
        var select = fs.querySelector('select');
        if (select) return select.value;
        return Array.from(fs.querySelectorAll('input')).find(function (radio) {
          return radio === target || radio.checked;
        })?.value;
      });
  };

  /* ── Fix 2: updateAvailableOptions ── */
  proto.updateAvailableOptions = function (target) {
    var firstValue = this.querySelector(':checked')?.value;
    if (!firstValue) return;

    var matchingVariants = this.getVariantData().filter(function (v) {
      return v.option1 === firstValue;
    });

    var groups = Array.from(this.querySelectorAll('fieldset, .variant-wrapper'));
    var self = this;

    groups.forEach(function (group, i) {
      // Skip the first group (option1) and the group that was just changed
      if (i === 0 || target.closest('fieldset') === group) return;

      var inputs = Array.from(group.querySelectorAll('input[type="radio"], option'));
      var prevValue = groups[i - 1].querySelector(':checked')?.value;

      var available = matchingVariants
        .filter(function (v) { return v.available && v['option' + i] === prevValue; })
        .map(function (v) { return v['option' + (i + 1)]; });

      self.setInputStates(inputs, available);
    });
  };
})();